import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Wrapper from '../components/Wrapper';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { setCookie, getCookie } from '../utilities/cookie';

const Cookie = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const isCoockiesAccepted = getCookie('acceptCookie');
        setOpen(!(isCoockiesAccepted === 'true'));
    }, []);

    const handleClickAccept = () => {
        setCookie('acceptCookie', true);
        setOpen(false);
    };

    const alertMessage = () => {
        alert('Aby przejść do serwisu musisz zaakceptować politykę plików cookies.');
    };

    const createMarkup = () => {
        return {__html: cookiesText};
    };

    return (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={open}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>Polityka plików cookies</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description' dangerouslySetInnerHTML={createMarkup()}>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={alertMessage} color='primary'>
                Rezygnuję
            </Button>
            <Button onClick={handleClickAccept} color='primary'>
                Akceptuję
            </Button>
          </DialogActions>
        </Dialog>
      );
};

export default Cookie;

ReactDOM.render(
    <Wrapper productionPrefix='coo' seed='cookie-pluigin'>
      <Cookie />
    </Wrapper>,
    document.getElementById('cookie-plugin'),
  );
